export const RED_FLAG_MESSAGE = "iredflag";
export const RED_FLAG_CANCEL_MESSAGE = "iredflagcancel";
